var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 pb-4 pl-3 pr-3",attrs:{"id":"content"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }